const { Cookie, RequestContext } = require('../cookie');

module.exports = class ExpUtils {
  static PROPS = {
    COMMON: {
      expCookieName: 'SEED',
      expSessionKey: 'ExpMetaData',
      apiSessionKey: 'expEndpoint',
      sessionTTL: 1000 * 60 * 60 * 24, // 24 hours in millisecond
      expTagssessionTTL: 1000 * 60 * 60 * 0.5, // 30 minutes in millisecond
      expTagsFiredSessionKey: 'ExpTagsFired',
    },
    MEW: {
      sessionTTL: 1000 * 60 * 60 * 6, // 6 hours in milliseconds
    },
    env: undefined,
    brand: undefined,
    data: null,
  };

  /**
   * @returns window.location
   */
  static getLocation = () => window.location

  /**
   * Utility
   * @param {Array} list
   * @param {String} value
   * @returns
   */
  static includes = (list, value) => list.includes(value)

  /**
   * isArray
   * @param {*} array
   * @returns {boolean}
   */
  static isArray = (array) => {
    if (
      Array.isArray(array)
        && array !== undefined
        && array.length !== 0
        && array[0] !== ''
    ) {
      return true;
    }
    return false;
  }

  /**
   * getApiEndpoint
   * @returns Experimentation api endpoint
   */
  static getApiEndpoint = () => process.env.EXPERIMENTATION_HOST || this.getDefaultHostBasedOnEnv()

  /**
   * Experimentation host
   * @returns Experimentation api endpoint
   */
  static getDefaultHostBasedOnEnv = () => {
    const location = ExpUtils.getLocation().href;
    if (location.indexOf('codemacys.fds') > -1) {
      return '//exp-core-mcom.staging.devops.fds.com';
    }
    if (location.indexOf('codebloomingdales.fds') > -1) {
      return '//exp-core-bcom.staging.devops.fds.com';
    }
    if (location.indexOf('macys.com') > -1) {
      return '//expcore.macys.com';
    }
    if (location.indexOf('bloomingdales.com') > -1) {
      return '//expcore.bloomingdales.com';
    }
    if (location.indexOf('mcom') > -1) {
      return '//exp-core-mcom.staging.devops.fds.com';
    }
    if (location.indexOf('bcom') > -1) {
      return '//exp-core-bcom.staging.devops.fds.com';
    }
    return '//exp-core-mcom.staging.devops.fds.com';
  }

  /**
  * webpage is desktop or mobile
  * @returns {string} desktop or mobile
  */
   static setEnv = () => {
     let isMobile = false;
     const clientSideObject = RequestContext.generateClientSideRequest();
     const { cookies } = clientSideObject;
     const device = Cookie.getDeviceTypeFromCookie(cookies);
     if (ExpUtils.getLocation().href.indexOf('//m.') > -1) {
       isMobile = true;
     } else if (device !== undefined && device !== 'PC') {
       isMobile = true;
     }
     ExpUtils.PROPS.env = isMobile ? 'MEW' : 'DESKTOP';
     return ExpUtils.PROPS.env;
   }

  /**
  * brand of webpage
  * @returns {string} mcom or bacom
  */
  static setBrand = () => {
    if (ExpUtils.getLocation().href.indexOf('macys') > -1) {
      ExpUtils.PROPS.brand = 'mcom';
    } else if (ExpUtils.getLocation().href.indexOf('mcom') > -1) {
      ExpUtils.PROPS.brand = 'mcom';
    } else if (
      ExpUtils.getLocation().href.indexOf('bloomingdales') > -1
    ) {
      ExpUtils.PROPS.brand = 'bcom';
    } else if (ExpUtils.getLocation().href.indexOf('bcom') > -1) {
      ExpUtils.PROPS.brand = 'bcom';
    } else {
      ExpUtils.PROPS.brand = 'mcom';
    }
    return ExpUtils.PROPS.brand;
  }

  /**
  *
  * @param {*} data
  */
   static setData = (data) => {
     ExpUtils.PROPS.data = data;
   }

  /**
   * get cookie by name or SEGMENT cookie
   * @param {string} cookieName
   * @returns
   */
  static getCookieForExperiment = (cookieName) => {
    let cookie;
    if (cookieName) {
      cookie = Cookie.get(cookieName);
      return cookie;
    }
    // implement manual cookie override for testing purposes
    const loc = ExpUtils.getLocation();
    const param = loc.search.match(/[?|&]experiment=([^&]+)/)
        || loc.search.match(/[?|&]segment=([^&]+)/);
    if (param) {
      // info('Overriding experimentation.');
      return this.decodeCookieForExperiment(`{"EXPERIMENT":[${param[1]}]}`);
    }
    // get regular cookie value
    cookie = Cookie.get('SEGMENT');
    if (cookie) {
      return this.decodeCookieForExperiment(cookie);
    }
    return undefined;
  }

  /**
   *
   * @param {string} SEGMENT cookie
   * @returns EXPERIMENT value
   */
  static decodeCookieForExperiment = (ck) => {
    let cookie;
    const result = {};
    try {
      cookie = JSON.parse(ck).EXPERIMENT;
      for (let i = 0, l = cookie.length; i < l; i += 1) {
        result[cookie[i]] = cookie[i];
      }
    } catch (e) {} // eslint-disable-line no-empty
    return result;
  }

  static queryString = (search) => {
    const queryStr = search;
    const queryArr = queryStr.replace('?', '').split('&');
    const queryParams = {};

    for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
      const qArr = queryArr[q].split('=');
      queryParams[qArr[0]] = qArr[1];
    }

    return queryParams;
  };
};
